import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

const CheckboxField = ({ input, label, meta: { error, touched } }) => {
  return (
    <FormGroup>
      <Label for={input.name}>{label}</Label>
      <Input {...input} checked={input.value} type="checkbox" style={{ marginLeft: '1rem' }} />
    </FormGroup>
  );
};

export default CheckboxField;



// WEBPACK FOOTER //
// ./src/components/common/CheckboxField.js